import { Box, Text, Image, Card, DateInput, ResponsiveContext } from 'grommet';
import React, { useEffect } from 'react';
import appartment from '../../../images/appartment.png'
import maison from '../../../images/m1.png'
import receptionist from '../../../images/receptioniste.png'
import franchise from '../../../images/franchise.png'
import { getBounds } from '../../../services/services';
import { ABONNEMENT, BIEN_TYPE, CLIENT_TYPE, PRODUCT, RESIDENCE_TYPE } from '../../../services/types';
import PrimaryButton from '../../elements/button';
import SelectableCard from '../../elements/selectable_card';
import { getSimpleDateFR, isPhone, toCurrency } from '../../../services/utils';
import translate from '../../../i18n/translate';


const getTotalAmount = devis => {
    let price = devis.estimatedPrice;
    let frais = devis.frais_dossier || 0;
    let promo = (devis.promo || {}).value || 0;
    return price + frais - promo;
}

const getMonthlyAmount = devis => {
    return getTotalAmount(devis) / 12;
}

const OptionsPrice = ({ devis, onDevisChange, toStartStep, product, initPrice }) => {
    const isMH = product === PRODUCT.MH;
    const isMHTEMPO = product === PRODUCT.MH_TEMPO;
    const isPNO = product === PRODUCT.PNO;

    useEffect(() => {
        initPrice();
    }, []);
    return (
        <ResponsiveContext.Consumer>
            {size => (
                <Box align='center' justify='center' gap='small' pad={'small'}>
                    <Box width={'large'} gap='medium' align='center' justify='center'>
                        <Box width={'small'} align='center'>
                            <Image src={devis.bienType === BIEN_TYPE.appartement ? appartment : maison} />
                        </Box>
                        {isMH &&
                            <Text textAlign='center'>
                                {`${translate('vous_etes_option')} `}
                                <strong>{devis.clientType === CLIENT_TYPE.locataire ? translate('locataire').toLowerCase() : translate('proprietaire').toLowerCase()} </strong>
                                {devis.bienType === BIEN_TYPE.appartement ? `${translate('un')} ` : `${translate('une')} `}
                                <strong>{devis.bienType === BIEN_TYPE.appartement ? translate('appartement').toLowerCase() : translate('maison').toLowerCase()}
                                </strong><br /> {translate('de')} {devis.totalRooms} {devis.totalRooms > 1 ? translate('pieces') : translate('piece')}
                                <strong>{devis.residenceType === RESIDENCE_TYPE.principale ? ` ${translate('principale').toLowerCase()}` : ` ${translate('secodaire').toLowerCase()}`}</strong>.
                            </Text>
                        }
                        {isPNO &&
                            <Text textAlign='center'>
                                {translate('mettez_votre')} <strong>{devis.bienType}</strong> {translate('en')} <strong>{devis.locationDuration.toLowerCase()}</strong> {translate('de')} {devis.totalRooms}
                                <span> </span>{translate('pieces_de')} <strong>{devis.surface} m2</strong>.
                            </Text>
                        }

                        <SelectableCard
                            textComponent={
                                <Text textAlign='center'>
                                    {translate('prix_title')} <br />
                                    {`${translate('est_de')} `}

                                    {isMHTEMPO ?
                                        <b>{toCurrency(devis.estimatedPrice)}</b> :
                                        <strong>{toCurrency(getTotalAmount(devis))} / {translate('year')}</strong>

                                    }
                                    {isMHTEMPO ?
                                        <span>
                                            {` ${translate('duration_from')} `}
                                            <b>{getSimpleDateFR(devis.effectiveDate)}</b>
                                            {` ${translate('au')} `}
                                            <b>{getSimpleDateFR(devis.date_fin)}</b>

                                        </span>
                                        :
                                        null
                                    }
                                    <strong>{isMH ? ` ${translate('soit')} ${toCurrency(getMonthlyAmount(devis))} / ${translate('month')}` : ''}</strong>
                                </Text>
                            }
                            selected={true}
                            paddingVertical={10}
                            paddingHorizontal={40}
                        />

                        {isMHTEMPO ?
                            <Card justify="center" pad={'small'}>
                                <Box justify='center' align='center'>
                                    <Box direction={isPhone(size) ? 'column' : "row"} justify='center' align='center' gap='xsmall'>
                                        <Text>
                                            {translate('assure_begin_at')}
                                        </Text>
                                        <Text style={{ color: "#59A4F4", fontWeight: 'bold' }} >
                                            {devis.effectiveDate ? `${translate('le')} ${new Date(devis.effectiveDate).toLocaleDateString('fr-FR')}` : ` ${translate('twomorrow')}`}
                                        </Text>
                                        <DateInput
                                            calendarProps={{ bounds: getBounds(devis), locale: 'fr-FR' }}
                                            value={devis.effectiveDate}
                                            onChange={event => onDevisChange('effectiveDate', new Date(event.value), initPrice)}
                                        />

                                    </Box>
                                    <Box direction={isPhone(size) ? 'column' : "row"} justify='center' align='center' gap='xsmall'>
                                        <Text>
                                            {translate('assure_end_at')}
                                        </Text>
                                        <Text style={{ color: "#59A4F4", fontWeight: 'bold' }} >
                                            {devis.date_fin ? ` ${getSimpleDateFR(devis.date_fin)}` : ''}
                                        </Text>
                                        <DateInput
                                            calendarProps={{ bounds: getBounds(devis), locale: 'fr-FR' }}
                                            value={devis.effectiveDate}
                                            onChange={event => onDevisChange('date_fin', new Date(event.value), initPrice)}
                                        />
                                    </Box>
                                </Box>
                            </Card>
                            :
                            <Card justify="center" pad={'small'}>
                                <Box direction={isPhone(size) ? 'column' : "row"} justify='center' align='center' gap='xsmall'>
                                    <Text>
                                        {translate('assure_begin_at')}
                                    </Text>
                                    <Text style={{ color: "#59A4F4", fontWeight: 'bold' }} >
                                        {devis.effectiveDate ? `${translate('le')} ${new Date(devis.effectiveDate).toLocaleDateString('fr-FR')}` : ` ${translate('twomorrow')}`}
                                    </Text>
                                    <DateInput
                                        calendarProps={{ bounds: getBounds(devis), locale: 'fr-FR' }}
                                        value={devis.effectiveDate}
                                        onChange={event => onDevisChange('effectiveDate', new Date(event.value))}
                                    />
                                </Box>
                            </Card>
                        }

                        <Text textAlign='center'>
                            {translate('modifier_intro')}  {translate('cliquant_bouton')} <strong>{` ${translate('modifier')} `}</strong> {translate('ci_dessous')}
                        </Text>
                        {isPhone(size) ?
                            <Box style={{ width: '50%', background: "#59A4F4", height: 60}} round={{ size: 'medium' }}
                                justify='center' align="center" direction="row" gap="small"
                            >
                                 <PrimaryButton label={translate('modifier_button')} background={'#59A4F4'}
                                onClick={toStartStep}
                            />
                            </Box> :
                            <PrimaryButton label={translate('modifier_button')} background={'#59A4F4'}
                                onClick={toStartStep}
                            />}
                        

                        {isMH &&
                            <Box width={'large'} gap='medium' align='center' justify='center'>
                                <Text textAlign='center'>
                                    {translate('regler')}
                                </Text>
                                {isPhone(size) ?
                                    (<Box width={'full'} justify='center' align="center" gap="small" direction="row">
                                        <Box style={{ width: '50%', background: devis.abonnement === ABONNEMENT.annual ? '#E92C70' : '#F4F4F4', height: 60 }} round={{ size: 'medium' }}
                                            justify='center' align="center" direction="row" gap="small"
                                        >
                                            <PrimaryButton label={translate('annuellement')}
                                                background={devis.abonnement === ABONNEMENT.annual ? '#E92C70' : '#F4F4F4'}
                                                color={devis.abonnement === ABONNEMENT.annual ? '#fff' : '#707070'}
                                                onClick={event => onDevisChange('abonnement', ABONNEMENT.annual)}
                                            />
                                        </Box>
                                        <Box style={{ width: '50%', background: devis.abonnement === ABONNEMENT.monthly ? '#E92C70' : '#F4F4F4', height: 60 }} round={{ size: 'medium' }}
                                            justify='center' align="center" direction="row" gap="small"
                                        >
                                            <PrimaryButton label={translate('mensuellement')}
                                                background={devis.abonnement === ABONNEMENT.monthly ? '#E92C70' : '#F4F4F4'}
                                                color={devis.abonnement === ABONNEMENT.monthly ? '#fff' : '#707070'}
                                                onClick={event => onDevisChange('abonnement', ABONNEMENT.monthly)}
                                            />
                                        </Box>
                                    </Box>) :
                                    <Box direction='row' gap='medium' justify='center' align='center'>
                                        <PrimaryButton label={translate('annuellement')}
                                            background={devis.abonnement === ABONNEMENT.annual ? '#E92C70' : '#F4F4F4'}
                                            color={devis.abonnement === ABONNEMENT.annual ? '#fff' : '#707070'}
                                            onClick={event => onDevisChange('abonnement', ABONNEMENT.annual)}
                                        />
                                        <PrimaryButton label={translate('mensuellement')}
                                            background={devis.abonnement === ABONNEMENT.monthly ? '#E92C70' : '#F4F4F4'}
                                            color={devis.abonnement === ABONNEMENT.monthly ? '#fff' : '#707070'}
                                            onClick={event => onDevisChange('abonnement', ABONNEMENT.monthly)}
                                        />
                                    </Box>}
                            </Box>
                        }

                        <Box width={'small'} align='center'>
                            <Image src={receptionist} />
                        </Box>
                        <Text><strong>{translate('valeur_bien')}</strong></Text>
                        <Text textAlign='center'>
                            {translate('estimer_bien')}
                        </Text>

                        {isMH &&
                            <Box direction='row' gap='medium' justify='center' align='center'>
                                <SelectableCard
                                    selected={devis.option === 'Trusti base'}
                                    title={toCurrency(devis.minCapitalMobilier)}
                                    subTitle={'Trusti base'}
                                    onClick={() => onDevisChange('option', 'Trusti base', () => initPrice())}
                                />
                                <SelectableCard
                                    selected={devis.option === 'Trusti confort'}
                                    title={toCurrency(devis.maxCapitalMobilier)}
                                    subTitle={'Trusti confort'}
                                    onClick={() => onDevisChange('option', 'Trusti confort', () => initPrice())}
                                />
                            </Box>
                        }

                        {isMHTEMPO &&
                            <Box direction='row' gap='medium' justify='center' align='center'>
                                <SelectableCard
                                    selected={true}
                                    title={toCurrency(parseFloat(devis.rawResponse?.capital_mobilier))}
                                    subTitle={'Trusti base'}
                                />
                            </Box>
                        }

                        {isPNO &&
                            <Box direction='row' gap='medium' justify='center' align='center'>
                                {devis.bienType === BIEN_TYPE.appartement &&
                                    <SelectableCard
                                        selected={devis.capitalMobilier === 0}
                                        title={'0 €'}
                                        onClick={() => onDevisChange('capitalMobilier', 0, () => initPrice())}
                                    />
                                }
                                <SelectableCard
                                    selected={devis.capitalMobilier === 10000}
                                    title={'10 000 €'}
                                    onClick={() => onDevisChange('capitalMobilier', 10000, () => initPrice())}
                                />
                                <SelectableCard
                                    selected={devis.capitalMobilier === 20000}
                                    title={'20 000 €'}
                                    onClick={() => onDevisChange('capitalMobilier', 20000, () => initPrice())}
                                />
                            </Box>
                        }

                        {isMH &&
                            <Box width={'large'} gap='medium' align='center' justify='center'>
                                <Text><strong>{translate('objet_valeur')}</strong></Text>
                                <Text>{translate('couvert')}</Text>
                                <PrimaryButton label={devis.option === 'Trusti base' ? toCurrency(0.1 * devis.minCapitalMobilier) : toCurrency(0.2 * devis.maxCapitalMobilier)} />
                                <Text size='small' style={{ textDecoration: 'underline' }}>{translate('savoir_plus')}</Text>
                                <Text><br /><strong>{translate('votre_franchise')}</strong><br /></Text>
                                <Text>{translate('franchise_desc')}</Text>

                                <Box direction='row' gap='medium' justify='center' align='center'>
                                    <SelectableCard
                                        selected={devis.option === 'Trusti base'}
                                        title={'153,35 €'}
                                        subTitle={'Trusti base'}
                                        onClick={() => onDevisChange('option', 'Trusti base', () => initPrice())}
                                    />
                                    <SelectableCard
                                        selected={devis.option === 'Trusti confort'}
                                        title={'0 €'}
                                        subTitle={'Trusti confort'}
                                        onClick={() => onDevisChange('option', 'Trusti confort', () => initPrice())}
                                    />
                                </Box>
                            </Box>
                        }

                        {isMHTEMPO &&
                            <Box width={'large'} gap='medium' align='center' justify='center'>
                                <Text><strong>{translate('objet_valeur')}</strong></Text>
                                <Text>{translate('couvert')}</Text>
                                <PrimaryButton label={toCurrency(parseFloat(devis.rawResponse?.object_valeur))} />
                                <Text size='small' style={{ textDecoration: 'underline' }}>{translate('savoir_plus')}</Text>
                                <Text><br /><strong>{translate('votre_franchise')}</strong><br /></Text>
                                <Text>{translate('franchise_desc')}</Text>

                                <Box direction='row' gap='medium' justify='center' align='center'>
                                    <SelectableCard
                                        selected={true}
                                        title={'153,35 €'}
                                        subTitle={'Trusti base'}
                                    />
                                </Box>
                            </Box>
                        }
                        {isPNO &&
                            <Box width={'large'} gap='medium' align='center' justify='center'>
                                <Box width={'xsmall'} align='center'>
                                    <Image src={franchise} />
                                </Box>
                                <Text><strong>{translate('votre_franchise')}</strong></Text>
                                <Text textAlign='center'>
                                    {translate('franchise_desc_pno')}
                                </Text>
                            </Box>
                        }

                        <Box background={'#F4F4F4'} round={{ size: 'small' }} gap={'medium'} width={'full'} pad={"medium"}>
                            {isMH &&
                                <Box justify='center' gap='medium'>
                                    <Box justify='center' direction={isPhone(size) ? 'column' : 'row'} gap='medium'>
                                        <Box>
                                            <Box round={{ size: 'small' }} color='#707070' pad={'small'} gap='small'>
                                                <Text color='#707070' ><strong>{translate('garantie_inclus')}</strong></Text>
                                                <Text color='#707070' >
                                                    - {translate('incendie')}<br />
                                                    - {translate('attentat')}<br />
                                                    - {translate('dommage')}<br />
                                                    - {translate('degats')}<br />
                                                    - {translate('climatique')}<br />
                                                    - {translate('glaces')}<br />
                                                    - {translate('technologie')}<br />
                                                    - {translate('assistance')}<br />
                                                    - {translate('vol_vandalisme')}<br />
                                                    - {translate('responsabilite_logement')}<br />
                                                    - {translate('responsabilite_prive')}<br />
                                                    - {translate('villegiature')}<br />
                                                    - {translate('valeur_neuf')}<br />
                                                </Text>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Box background={"#59A4F4"} round={{ size: 'small' }} color='#fff' pad={'small'} gap='small'>
                                                <Text color='#fff' ><strong>{translate('option_confort')}</strong></Text>
                                                <Text color='#fff' >
                                                    - {translate('energie')}<br />
                                                    - {translate('piscine')}<br />
                                                    - {translate('location_saisonniere')}<br />
                                                    - {translate('valeur_neuf_contenu')}<br />
                                                </Text>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box justify='center'>
                                        <Text textAlign='center' color='#707070' >
                                            <b>{translate('inclus')}</b> : {translate('inclus_des')}
                                        </Text>
                                    </Box>
                                    <Box direction='row' gap='medium' justify='center' align='center'
                                        onClick={() => window.open('https://www.trustiway.com/fr/particuliers/assurance-immobilier/assurance-habitation/', '_blank').focus()}
                                    >
                                        <Text color='#707070' size='small' style={{ textDecoration: 'underline' }}>{translate('savoir_plus')}</Text>
                                    </Box>
                                    <Box direction={isPhone(size) ? 'column' : 'row'} gap='medium' justify='center' align='center'>
                                        <PrimaryButton label={translate('condition_general_base')} onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2021/09/CG-Habitation-LogiBASE.pdf', '_blank').focus()} />
                                        <PrimaryButton label={translate('condition_general_confort')} onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2021/09/CG-Habitation-LogiCONFORT.pdf', '_blank').focus()} />
                                    </Box>
                                    <Box direction='row' gap='medium' justify='center' align='center'>
                                        <PrimaryButton label={translate('document_info')} onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2021/09/IPID-Habitation-ADB.pdf', '_blank').focus()} />
                                    </Box>
                                </Box>
                            }
                            {isMHTEMPO &&
                                <Box justify='center' gap='medium'>
                                    <Box justify='center' direction='row' gap='medium'>
                                        <Box>
                                            <Box round={{ size: 'small' }} color='#707070' pad={'small'} gap='small'>
                                                <Text color='#707070' ><strong>{translate('garantie_inclus')}</strong></Text>
                                                <Text color='#707070' >
                                                    - {translate('incendie')}<br />
                                                    - {translate('attentat')}<br />
                                                    - {translate('dommage')}<br />
                                                    - {translate('degats')}<br />
                                                    - {translate('climatique')}<br />
                                                    - {translate('glaces')}<br />
                                                    - {translate('technologie')}<br />
                                                    - {translate('assistance')}<br />
                                                    - {translate('vol_vandalisme')}<br />
                                                    - {translate('responsabilite_logement')}<br />
                                                    - {translate('responsabilite_prive')}<br />
                                                    - {translate('villegiature')}<br />
                                                    - {translate('valeur_neuf')}<br />
                                                </Text>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box direction='row' gap='medium' justify='center' align='center'
                                        onClick={() => window.open('https://www.trustiway.com/fr/particuliers/assurance-immobilier/assurance-habitation/', '_blank').focus()}
                                    >
                                        <Text color='#707070' size='small' style={{ textDecoration: 'underline' }}>{translate('savoir_plus')}</Text>
                                    </Box>
                                    <Box direction={isPhone(size) ? 'column' : 'row'} gap='medium' justify='center' align='center'>
                                        <PrimaryButton label={translate('condition_general_base')} onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2021/09/CG-Habitation-LogiBASE.pdf', '_blank').focus()} />
                                        <PrimaryButton label={translate('document_info')} onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2021/09/IPID-Habitation-ADB.pdf', '_blank').focus()} />
                                    </Box>
                                </Box>
                            }

                            {isPNO &&
                                <Box justify='center' gap='medium'>
                                    <Box justify='center'direction={isPhone(size) ? 'column' : 'row'} gap='medium'>
                                        <Box>
                                            <Box round={{ size: 'small' }} color='#707070' pad={'small'} gap='small'>
                                                <Text color='#707070' ><strong>{translate('garantie_inclus')}</strong></Text>
                                                <Text color='#707070' >
                                                    - {translate('incendie')}<br />
                                                    - {translate('attentat')}<br />
                                                    - {translate('dommage')}<br />
                                                    - {translate('degats')}<br />
                                                    - {translate('climatique')}<br />
                                                    - {translate('glaces')}<br />
                                                    - {translate('catastrophes')}<br />
                                                </Text>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Box round={{ size: 'small' }} color='#707070' pad={'small'} gap='small'>
                                                <Text color='#707070' ><strong>{translate('garantie_inclus')}</strong></Text>
                                                <Text color='#707070' >
                                                    - {translate('technologie')}<br />
                                                    - {translate('risque_locatif')}<br />
                                                    - {translate('vol_vandalisme')}<br />
                                                    - {translate('responsabilite_prop')}<br />
                                                    - {translate('renonciation')}<br />
                                                    - {translate('valeur_neuf')}<br />
                                                </Text>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box direction={isPhone(size) ? 'column' : 'row'} gap='medium' justify='center' align='center'>
                                        <PrimaryButton label={translate('condition_generale')}
                                            onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2020/08/CG-PNO-Bailleur.pdf', '_blank').focus()} />
                                        <PrimaryButton label={translate('document_info')}
                                            onClick={() => window.open('https://www.trustiway.com/wp-content/uploads/2021/05/Fiche-IPID-PNO-Bailleur.pdf', '_blank').focus()} />
                                    </Box>
                                </Box>
                            }

                        </Box>
                    </Box>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    )
}

export default OptionsPrice;